module.exports = {
	colors: {
		main: '#5e02d6',
		sec: '#dbc815',
		alt: '#5e02d6',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	showSchoolDay: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963944416140', '+963953419672'],
		phones: [],
		address: 'حلب - الشهباء الجديدة شارع السنديان',
		data: [0, 0],
		email: null,
		facebook: 'https://www.facebook.com/Alawalschool?mibextid=ZbWKwL',
		privacy: null,
		details: [
			{
				title: 'عنّا',
				content: [
					'أن نكونَ مركزاً فريداً رائداً في إعداد وتهيئةِ جيلٍ جَديدٍ قادرٍ على الابتكارِ والابداعِ، وقيادة مجتمعهم نحو التغيير الإيجابي والتميّز في الأداء، نعتمدُ بذلك مفهومَ التنميةِ البشريّةِ بخبراتٍ وتقنيّات متطوّرة، لطاقات طلابنا ضمنَ بيئةٍ مُحفزّة للتعلّم والإبداعِ الفكري',
				],
			},
		],
	},

	pwa: {
		name: 'مؤسسة الأول التعليمية الخاصة',
		shortName: 'مؤسسة الأول التعليمية الخاصة',
		description: 'تطبيق مؤسسة الأول التعليمية الخاصة - نسخة محمولة من تطبيق الموبيال.',
	},
};
